<div>
    <table mat-table [dataSource]="dataSource" *ngIf="dataSource?.data?.length !== 0" class="w-100" matSort
        matSortActive="numeroFolha" matSortDirection="asc">

        <!-- Coluna: Numero Folha -->
        <ng-container matColumnDef="numeroFolha">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº Folha Teste</th>
            <td mat-cell *matCellDef="let element; let i = index">
                {{ element?.numeroFolha }}
            </td>
        </ng-container>

        <!-- Coluna: Identificacao Item da amostra -->
        <ng-container matColumnDef="amostraItemDescricao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Identificação Item Amostra</th>
            <td mat-cell *matCellDef="let element">
                {{ element?.amostraItemDescricao }}
            </td>
        </ng-container>

        <!-- Coluna: Data Preenchimento -->
        <ng-container matColumnDef="dataFinalizado">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Data de Preenchimento</th>
            <td mat-cell *matCellDef="let element">
                {{ element?.dataFinalizado | date: "dd/MM/yyyy" }}
            </td>
        </ng-container>

        <!-- Coluna: Auditor Responsável  -->
        <ng-container matColumnDef="nomeResponsavelFinalizado">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Auditor Responsável</th>
            <td mat-cell *matCellDef="let element">
                {{ element?.nomeResponsavelFinalizado }}
            </td>
        </ng-container>

        <!-- Coluna: Status  -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
                <span *ngIf="element?.status === 1" class="badge bg-gray-dark text-xs">{{ element?.statusDesc }}</span>
                <span *ngIf="element?.status === 2" class="badge bg-success text-xs">{{ element?.statusDesc }}</span>
                <span *ngIf="element?.status === 3" class="badge bg-warning text-xs">{{ element?.statusDesc }}</span>
                <span *ngIf="element?.status === 4" class="badge bg-danger text-xs">{{ element?.statusDesc }}</span>
                <ng-container *ngIf="element?.status === 4">
                    <i class="fas fa-info-circle" [matTooltip]="formatarTooltipCanc(element)"
                        matTooltipClass="tooltip-cancelamento" matTooltipPosition="above"
                        style="cursor: pointer; margin-left: 0.5rem;">
                    </i>
                </ng-container>
            </td>
        </ng-container>

        <!-- Coluna: Ações -->
        <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
            <td mat-cell *matCellDef="let element; let index">
                <div class="w-100 d-flex justify-content-center">
                    <button class="icon-btn btn btn-info btn-xs" title="Visualizar Folha Teste"
                        (click)="modalQuestao('Visualizar', true, element)">
                        <i class="far fas fa-eye"></i>
                    </button>
                    <button type="button" *ngIf="!visualizar && element?.status != 4 && statusProgramaTrabalho == 1 && !bloqueadoPorMatriz"
                        class="btn btn-primary btn-xs ml-1" title="Preencher Folha Teste"
                        (click)="modalQuestao('Preencher', false, element)">
                        <i class="fas fa-pen"></i>
                    </button>
                    <button type="button" *ngIf="!visualizar && statusProgramaTrabalho == 1"
                        class="btn btn-info btn-xs ml-1" title="Imprimir Folha Teste" (click)="imprimir(element)">
                        <i class="far fas fa-print"></i>
                    </button>
                    <button type="button"
                        *ngIf="!visualizar && element?.status != 4 && element?.origemPlanejamento && statusProgramaTrabalho == 1 && !bloqueadoPorMatriz"
                        class="btn btn-warning btn-xs ml-1" title="Cancelar Folha Teste"
                        (click)="modalCancelar(element)">
                        <i class="fas fa-ban"></i>
                    </button>
                    <button type="button" *ngIf="!visualizar && element?.status == 4 && statusProgramaTrabalho == 1 && !bloqueadoPorMatriz"
                        class="btn btn-primary btn-xs ml-1" title="Habilitar Folha Teste" (click)="habilitar(element)">
                        <i class="fas fa-check"></i>
                    </button>
                    <button type="button"
                        *ngIf="!visualizar && !element?.origemPlanejamento && statusProgramaTrabalho == 1 && !bloqueadoPorMatriz"
                        class="btn btn-danger btn-xs ml-1" (click)="excluir(element)" title="Excluir Folha Teste">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
            </td>
        </ng-container>

        <!-- Cabeçalho da Tabela -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <!-- Linhas  -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns">
        </tr>
    </table>

    <!-- Sem dados -->
    <h5 *ngIf="dataSource?.data?.length === 0" class="table-no-data">
        Nenhum registro encontrado.
    </h5>

    <!-- Paginador -->
    <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>